/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form } from "@renderbus/ui";
import {
  CardListContent,
  CpuQingCloudWrapper,
  InputNumberWrapper,
  QingCloudCard,
  QingCloudCardList,
  QingCloudRechargeWrapper,
  QingCloudWrapper,
} from "./atom";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import {
  CouponTypeCode,
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useEffect, useState } from "react";
import CheckIcon from "@/assets/icons/topup/check";
import CouponIcon from "@/assets/icons/topup/coupon-icon";
import LeftIcon from "@/assets/icons/topup/left-icon";
import RightIcon from "@/assets/icons/topup/right-icon";
import { useAnimationTopUpStore } from "../../store";
import {
  presentAmountCalculate,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import { BindActivityInfo } from "@/components/top-up/types";
import { QingCloudName } from "../../constants/animation-balance-info";
import { useScrollCard } from "./hooks/useScrollCard";
import { PaymentWay } from "../payment-way";
import { RechargeTips } from "../../help/tips";
import { ExtraWelfareTipType } from "../../types";
import { CommonCornerMark, CommonTitle, CommonUpperPart } from "../../atom";
import ActivityRule from "@/components/top-up/components/activity-rule";

export function QingCloudRecharge({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { t } = useTranslation("topup");
  const { userProperty } = useUserPropertyStore();
  const {
    isZh,
    currencySymbol,
    userCumulative,
    isAnimationActiveOverTime,
    userInfo,
    userLevel,
  } = useGlobalStore();

  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const [checkCard, setCheckCard] = useState(activityInfo.activityDetail[0]);
  const [error, setError] = useState("");

  const [searchParams] = useSearchParams();
  const amount = useAnimationTopUpStore((state) => state.amount);
  const paying = useAnimationTopUpStore((state) => state.paying);
  const cpuQingCloudAmount = useAnimationTopUpStore(
    (state) => state.cpuQingCloudAmount
  );
  const activeName = useAnimationTopUpStore((state) => state.activeName);
  const addPayRecord = useAnimationTopUpStore((state) => state.addPayRecord);
  const { setter: setAnimationTopUpStore } = useAnimationTopUpStore();
  const isCPUQingCloud =
    activityInfo.activityDetail[0].couponType === CouponTypeCode.CPUQingCloud;
  const { wrapperRef, isLeftHidden, isRightHidden, scrollRight, scrollLeft } =
    useScrollCard();
  const [qingyunTip, setQingYunTip] = useState<ExtraWelfareTipType[]>();

  const onCpuCloudAmountChange = (value: any) => {
    const val = value ? Math.floor(parseFloat(value)) : value;
    setAnimationTopUpStore({
      cpuQingCloudAmount: val,
    });
    if (val >= 2000 && val <= 4999) {
      setAnimationTopUpStore({
        amount: val,
      });
      setError("");
    } else {
      setAnimationTopUpStore({
        amount: 0,
      });
      if (typeof val !== "undefined" && val !== null) {
        setError(`${t("topup_qingyun_check_over")}`);
        return;
      }
      setError("");
    }
  };

  const onPasteChange = (event: any) => {
    event.preventDefault();
  };

  const onOtherRechargeKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    setCheckCard({});
    if (keyCode === 46) {
      e.preventDefault();
      return false;
    }
    if (
      !(
        (e.key >= "0" && e.key <= "9") ||
        e.key === "Backspace" ||
        e.key === "Delete" ||
        e.key === "ArrowLeft" ||
        e.key === "ArrowRight"
      )
    ) {
      e.preventDefault();
      return false;
    }
    const input = (e.target || e.srcElement).value;
    if (
      input &&
      input.length >= 4 &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key)
    ) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  const qrcodeLink = () => {
    const paramsStr = `&${QRCODE_QUERY_MAP.orderType}=${
      isCPUQingCloud
        ? OrderPaymentTypeCode.QingCloudCPUOrder
        : OrderPaymentTypeCode.QingCloudGPUOrder
    }&${QRCODE_QUERY_MAP.amount}=${Number(amount)}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${PaymentPurposeCode.ActivityRecharge}`;

    return paramsStr;
  };

  const onClickCantScanCode = async () => {
    let params = {};
    params = {
      agent: searchParams.get("agent") || "",
      currency: userInfo?.zone,
      payMethod:
        activityInfo.activityDetail[0].couponType ===
        CouponTypeCode.GPUQingCloud
          ? PaymentTypeCode.GPUAlipay
          : PaymentTypeCode.CPUAlipay,
      amount: Number(amount),
      rechargeGoal: PaymentPurposeCode.ActivityRecharge,
      rechargeChannels: rechargeChannelsCode.Web,
    };
    await addPayRecord(params);
  };

  const preventWheel = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (
      [QingCloudName.CPUCloud, QingCloudName.GPUCloud].includes(
        activeName as QingCloudName
      )
    ) {
      setCheckCard(activityInfo.activityDetail[0]);
      setError("");
      setAnimationTopUpStore({
        amount: activityInfo.activityDetail[0].amount,
        cpuQingCloudAmount: null,
      });
    }
  }, [activeName]);

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(amount),
      userProperty,
      userLevel,
      userCumulative,
      currencySymbol,
      isAnimationActiveOverTime,
      activityInfo,
    });
    void rechargeTips.init();
    setQingYunTip(rechargeTips.extraWelfareTip);
  }, [amount, userProperty, currencySymbol, activityInfo]);

  useEffect(() => {
    // 防止滚轮滚动的自增自减
    const inputElement = document.querySelector(".qing-cloud-input input");
    if (inputElement) {
      inputElement.addEventListener("wheel", preventWheel, { passive: false });
    }
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventWheel);
      }
    };
  }, []);

  return (
    <QingCloudRechargeWrapper>
      <ActivityRule
        ruleList={rulesContentList(activityInfo, isZh)}
        openRuleDrawer={openActivityRuleDrawer}
        changeDrawer={(val) => {
          setOpenActivityRuleDrawer(val);
        }}
        activityInfo={activityInfo}
      />
      <CommonUpperPart>
        <QingCloudWrapper>
          <CardListContent>
            {activityInfo.activityDetail.length > 4 && !isLeftHidden && (
              <LeftIcon
                onClick={scrollLeft}
                className="scroll-button left-button"
              />
            )}
            <div className="qing-cloud-card-list-wrapper" ref={wrapperRef}>
              <QingCloudCardList className="cards-wrapper">
                {activityInfo.activityDetail.map((item) => {
                  const price = item.amount || 0;
                  const isCheckedCard = checkCard.amount === price;
                  return (
                    <QingCloudCard
                      isActive={isCheckedCard}
                      onClick={() => {
                        setCheckCard(item);
                        onCpuCloudAmountChange(null);
                        setAnimationTopUpStore((state) => {
                          state.amount = price;
                        });
                      }}
                      key={item.id}
                    >
                      {item.iconWord && item.iconWord !== "" && (
                        <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                      )}
                      <div className="recharge-price">
                        <div>
                          <span className="unit">{currencySymbol}</span>
                          <span className="price">{price}</span>
                        </div>
                        {isCheckedCard && <CheckIcon />}
                      </div>
                      <div className="extra-welfare">
                        <div className="tip-text">
                          {t("activity_qing_cloud_arrive")}
                        </div>
                        <div className="gift-amount">
                          <CouponIcon />
                          <span>
                            {currencySymbol}
                            {presentAmountCalculate(
                              activityInfo,
                              price,
                              item.presentAmount
                            ) ?? 0}
                            &nbsp;
                            {couponTypeTranslate(item.couponType ?? 0)}
                          </span>
                        </div>
                      </div>
                    </QingCloudCard>
                  );
                })}
              </QingCloudCardList>
            </div>
            {activityInfo.activityDetail.length > 4 && !isRightHidden && (
              <RightIcon
                onClick={scrollRight}
                className="scroll-button right-button"
              />
            )}
          </CardListContent>
        </QingCloudWrapper>
        {isCPUQingCloud && (
          <CpuQingCloudWrapper>
            <CommonTitle>{t("topup_other_amount")}</CommonTitle>
            <Form layout="vertical">
              <Form.Item validateStatus={error ? "error" : ""} help={error}>
                <InputNumberWrapper
                  className="qing-cloud-input"
                  size={"large"}
                  prefix={currencySymbol}
                  style={{ width: 220 }}
                  controls={false}
                  value={cpuQingCloudAmount}
                  onPaste={onPasteChange}
                  onChange={onCpuCloudAmountChange}
                  type="number"
                  pattern="[0-9]*"
                  // onKeyPress={onOtherRechargeKeyPress}
                  onKeyDown={onOtherRechargeKeyPress}
                  placeholder={t("general_enter_amount")}
                />
              </Form.Item>
            </Form>
          </CpuQingCloudWrapper>
        )}
      </CommonUpperPart>
      <PaymentWay
        paying={paying}
        onClickCantScanCode={() => void onClickCantScanCode()}
        qrcodeLink={qrcodeLink()}
        qingyunTip={qingyunTip}
      />
    </QingCloudRechargeWrapper>
  );
}
